import { Typography } from '@mui/material'
import { t } from 'i18next'
import { LoadingPreviewCard } from '../../../../components/LoadingElements'
import React, { useCallback, useEffect, useState } from 'react'
import CampaignPreviewCard from '../CampaignPreviewCard/CampaignPreviewCard'
import { Campaign } from '../../../../api/campaign/types'

type PreviewListProps = {
	campaigns: Campaign[]
	isLoading: boolean
}

const LIMIT_CAMPAIGN_NUMBER_TO_DISPLAY = 3

export default function PreviewList({ campaigns, isLoading }: PreviewListProps) {
	const [homeCampaigns, setHomeCampaigns] = useState<Campaign[]>([])

	useEffect(() => {
		if (!isLoading) {
			setHomeCampaigns(campaigns.slice(0, LIMIT_CAMPAIGN_NUMBER_TO_DISPLAY))
		}
	}, [campaigns, isLoading])

	const checkStatus = useCallback((campaign: any) => {
		if (campaign.campaign_state) {
			return 'COMPLETED'
		}
		return 'WAITING'
	}, [])

	return (
		<React.Fragment>
			{(isLoading || !!campaigns?.length) && (
				<Typography variant="h3" sx={{ mt: '64px' }}>
					{t('home.subtitle_2')}
				</Typography>
			)}
			{isLoading && Array.from({ length: LIMIT_CAMPAIGN_NUMBER_TO_DISPLAY }).map(() => <LoadingPreviewCard />)}
			{homeCampaigns?.map((campaign: any, index: React.Key) => (
				<CampaignPreviewCard
					key={index}
					campaignId={campaign.campaign_id}
					title={campaign.campaign_name}
					leads={`${campaign?.total_leads || 0} leads`}
					campaignType={campaign.campaign_type}
					status={checkStatus(campaign)}
					// timeAgo="2h ago"
					sx={{ mt: '8px' }}
				/>
			))}
		</React.Fragment>
	)
}
